var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOfekAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.047,
    height: 47.89,
    viewBox: "0 0 111.047 47.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2769",
    "data-name": "Rectangle 2769",
    width: 111.047,
    height: 47.89,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5255",
    "data-name": "Group 5255",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5254",
    "data-name": "Group 5254",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M111.047,22.17a3.233,3.233,0,0,1-3.461,2.93H77.353a3.075,3.075,0,0,1-3.261-2.93,3.075,3.075,0,0,1,3.261-2.93h30.233a3.233,3.233,0,0,1,3.461,2.93",
    fill: "#24cd78"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2766",
    "data-name": "Rectangle 2766",
    width: 5.859,
    height: 5.858,
    rx: 2.853,
    transform: "translate(99.55 8.491)",
    fill: "#fdbe0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2767",
    "data-name": "Rectangle 2767",
    d: "M2.853,0h.153A2.853,2.853,0,0,1,5.859,2.853V3A2.854,2.854,0,0,1,3.005,5.858H2.853A2.853,2.853,0,0,1,0,3.005V2.853A2.853,2.853,0,0,1,2.853,0Z",
    transform: "translate(49.988 8.491)",
    fill: "#24cd78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M24.451,11.344A2.857,2.857,0,0,0,21.6,8.491h-.153a2.859,2.859,0,0,0-2.853,2.853V11.5a2.856,2.856,0,0,0,2.853,2.853H21.6A2.857,2.857,0,0,0,24.451,11.5Z",
    fill: "#24cd78",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M15.945,11.344a2.857,2.857,0,0,0-2.853-2.853h-.153a2.859,2.859,0,0,0-2.853,2.853V11.5a2.856,2.856,0,0,0,2.853,2.853h.152A2.857,2.857,0,0,0,15.945,11.5Z",
    fill: "#24cd78",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M97.126,11.42a2.946,2.946,0,0,1-2.955,2.93H82.513a2.829,2.829,0,0,1-2.784-2.93,2.829,2.829,0,0,1,2.784-2.93H94.171a2.946,2.946,0,0,1,2.955,2.93",
    fill: "#f09"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 5.859,
    height: 5.858,
    rx: 2.853,
    transform: "translate(79.729 29.991)",
    fill: "#ff7a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M88.012,32.92a2.946,2.946,0,0,0,2.955,2.93h11.658a2.934,2.934,0,0,0,0-5.86H90.967a2.946,2.946,0,0,0-2.955,2.93",
    fill: "#34bbe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M12.944,47.89A18.148,18.148,0,0,1,7.339,47.1a11.564,11.564,0,0,1-4.058-2.217A9.206,9.206,0,0,1,.824,41.475,11.208,11.208,0,0,1,0,37.138a11.722,11.722,0,0,1,.193-2.062l.058-.327c.3-1.723.713-4.082,2.808-4.277.087-.008.172-.012.258-.012a5.564,5.564,0,0,1,1.615.322L5,30.8c1.252.382.94,2.143.735,3.309-.041.231-.078.438-.1.6a9.8,9.8,0,0,0,.257,4.721,5.727,5.727,0,0,0,1.46,2.145A6.894,6.894,0,0,0,9.789,42.99a10.427,10.427,0,0,0,3.413.51,11.928,11.928,0,0,0,3.438-.483,7.644,7.644,0,0,0,2.749-1.459A6.9,6.9,0,0,0,21.212,39.1a8.348,8.348,0,0,0,.667-3.33,8.759,8.759,0,0,1-1.554.284c-.57.052-1.078.078-1.514.078a10.541,10.541,0,0,1-4.137-.728A8.038,8.038,0,0,1,11.9,33.52a7.2,7.2,0,0,1-1.558-2.611,9.056,9.056,0,0,1-.486-2.884,8.769,8.769,0,0,1,.642-3.35,7.966,7.966,0,0,1,1.841-2.724,8.636,8.636,0,0,1,2.9-1.817,10.472,10.472,0,0,1,3.793-.659,10.925,10.925,0,0,1,1.784.155,7.571,7.571,0,0,1,1.832.554,7.242,7.242,0,0,1,1.708,1.082,6.66,6.66,0,0,1,1.427,1.727,9.383,9.383,0,0,1,.971,2.475,13.782,13.782,0,0,1,.359,3.323v5.59a14.819,14.819,0,0,1-1.083,5.851,11.867,11.867,0,0,1-2.992,4.237,12.709,12.709,0,0,1-4.5,2.563,17.764,17.764,0,0,1-5.595.858M18.39,23.712A3.035,3.035,0,0,0,17.076,24a3.2,3.2,0,0,0-1.068.827,4.132,4.132,0,0,0-.723,1.288,4.9,4.9,0,0,0-.27,1.666,4.645,4.645,0,0,0,.242,1.5,3.214,3.214,0,0,0,.764,1.24,3.752,3.752,0,0,0,1.352.849,5.624,5.624,0,0,0,1.993.316,6.917,6.917,0,0,0,.7-.037q.369-.037.721-.095t.66-.132a3.142,3.142,0,0,0,.428-.132V29.906a13.251,13.251,0,0,0-.311-3.167,5.61,5.61,0,0,0-.8-1.886,2.484,2.484,0,0,0-1.1-.9,3.574,3.574,0,0,0-1.275-.24",
    fill: "#5750fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M38.179,36.079a5.183,5.183,0,0,1-.785-.05,1.1,1.1,0,0,1-.551-.229.964.964,0,0,1-.3-.505,3.24,3.24,0,0,1-.081-.818v-1.34a3.643,3.643,0,0,1,.049-.645.92.92,0,0,1,.766-.781,4.032,4.032,0,0,1,.9-.08h5.654a7.6,7.6,0,0,1-.646-1.618,8.043,8.043,0,0,1-.312-2.217,8.235,8.235,0,0,1,2.5-5.979,8.631,8.631,0,0,1,2.8-1.788,10.119,10.119,0,0,1,6.9-.087A6.866,6.866,0,0,1,57.6,21.581a7.284,7.284,0,0,1,1.59,2.62,10.321,10.321,0,0,1,.553,3.48v8.4ZM51.254,23.712a3.028,3.028,0,0,0-1.314.294,3.231,3.231,0,0,0-1.068.82,4.084,4.084,0,0,0-.724,1.262,4.721,4.721,0,0,0-.269,1.631,4.187,4.187,0,0,0,.3,1.6,3.551,3.551,0,0,0,.841,1.238,3.7,3.7,0,0,0,1.333.8,5.446,5.446,0,0,0,1.805.28h2.361V28.466a8,8,0,0,0-.282-2.3,4.218,4.218,0,0,0-.732-1.459,2.554,2.554,0,0,0-1.03-.767,3.353,3.353,0,0,0-1.217-.23",
    fill: "#5750fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M66.809,36.164c-1.495,0-2.712-1.61-2.712-3.589V11.356c0-1.9,1.192-3.389,2.712-3.389s2.711,1.489,2.711,3.389V32.575c0,1.979-1.216,3.589-2.711,3.589",
    fill: "#5750fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M37.61,36.079a7.5,7.5,0,0,1-2.8-.469,5.05,5.05,0,0,1-1.924-1.326,5.33,5.33,0,0,1-1.108-2.059,9.373,9.373,0,0,1-.35-2.629L31.248,10.78c0-1.9,1.191-3.39,2.711-3.39s2.712,1.489,2.712,3.389l-.005,17.764a7.117,7.117,0,0,0,.14,1.55,2.441,2.441,0,0,0,.4.937,1.331,1.331,0,0,0,.647.464,3.069,3.069,0,0,0,.965.137h.938c.133,0,13.374.018,13.593.062l.1.021v4.294l-.107.018c-.012,0-.012,0-6.432,0l-6.409,0a4.646,4.646,0,0,1-.748.048Z",
    fill: "#5750fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M70.888,5.877a5.994,5.994,0,0,1-1.013-.112A10.385,10.385,0,0,1,68.852,5.5a13.958,13.958,0,0,1-1.781-.743,7.817,7.817,0,0,0-3.1-.981H63.9a1.99,1.99,0,0,0-.845.276,4.989,4.989,0,0,1-.486.22,2.068,2.068,0,0,1-.707.136,1.543,1.543,0,0,1-1.211-.587,1.663,1.663,0,0,1-.418-1.471A3.29,3.29,0,0,1,62.156.405,4.921,4.921,0,0,1,64.161,0a5.682,5.682,0,0,1,1.173.122,11.317,11.317,0,0,1,3.277,1.193c1.229.719,2.86,1.45,3.576-.207A1.047,1.047,0,0,1,73.208.433a2.309,2.309,0,0,1,2.122,1.35A2.278,2.278,0,0,1,75.1,3.555a4.984,4.984,0,0,1-.951,1.258,3.652,3.652,0,0,1-1.366.8,5.542,5.542,0,0,1-1.73.264Z",
    fill: "#5750fa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfekAr);
export default __webpack_public_path__ + "static/media/LogoOfekAR.86b7a02d99e9cfce55c02d45b12a9d61.svg";
export { ForwardRef as ReactComponent };